import {
    CHANGE_CALENDAR_SELECTED_LOCATION,
} from "../calendarActions";
import {selectLoggedInArtistID} from "../../auth/authSelector";
import {selectResourceFilter} from "../calendarResourceSelector";
import {saveArtistResourceFilter} from "../../../api/localArtistPersistence";
import {select, takeLatest} from "redux-saga/effects"

function* processResourceFilterChanged() {
    const artistId = yield select(state => selectLoggedInArtistID(state))
    const resourceFilter = yield select(state => selectResourceFilter(state))
    if (artistId) {
        saveArtistResourceFilter(artistId, resourceFilter)
    }
}

export function* watchChangeResourceFilter() {
    yield takeLatest([CHANGE_CALENDAR_SELECTED_LOCATION], processResourceFilterChanged)
}
